import type { ThemeConfig } from 'antd';

/**
 * Single source of truth for the admin panel's look.
 * Colours are mirrored in tailwind.config.js so utility classes agree with antd.
 */
export const colors = {
    primary: '#4f46e5',
    primaryHover: '#4338ca',
    success: '#059669',
    warning: '#d97706',
    danger: '#dc2626',

    ink: '#0f172a',
    body: '#334155',
    muted: '#64748b',
    faint: '#94a3b8',

    line: '#e2e8f0',
    surface: '#ffffff',
    canvas: '#f8fafc',
    sidebar: '#111827',
    sidebarHover: '#1f2937',
};

const fontStack =
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', " +
    "'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif";

const theme: ThemeConfig = {
    token: {
        colorPrimary: colors.primary,
        colorSuccess: colors.success,
        colorWarning: colors.warning,
        colorError: colors.danger,
        colorTextBase: colors.body,
        colorBorder: colors.line,
        colorBorderSecondary: colors.line,
        colorBgLayout: colors.canvas,

        fontFamily: fontStack,
        fontSize: 14,

        borderRadius: 8,
        borderRadiusLG: 12,
        borderRadiusSM: 6,

        controlHeight: 38,
        controlHeightSM: 30,

        boxShadowTertiary:
            '0 1px 2px 0 rgb(15 23 42 / 0.04), 0 1px 3px 0 rgb(15 23 42 / 0.06)',
    },
    components: {
        Table: {
            headerBg: '#f1f5f9',
            headerColor: colors.ink,
            headerSplitColor: 'transparent',
            borderColor: colors.line,
            rowHoverBg: '#f8fafc',
            cellPaddingBlock: 14,
            cellPaddingInline: 16,
            headerBorderRadius: 12,
            fontSize: 13,
        },
        Button: {
            fontWeight: 500,
            primaryShadow: 'none',
            defaultShadow: 'none',
            dangerShadow: 'none',
        },
        Input: {
            paddingBlock: 7,
        },
        Card: {
            headerFontSize: 15,
            paddingLG: 20,
        },
        Menu: {
            darkItemBg: 'transparent',
            darkPopupBg: colors.sidebar,
            darkSubMenuItemBg: 'transparent',
            darkItemSelectedBg: colors.primary,
            darkItemHoverBg: colors.sidebarHover,
            darkItemColor: '#cbd5e1',
            darkItemSelectedColor: '#ffffff',
            itemHeight: 42,
            iconSize: 16,
        },
        Tag: {
            borderRadiusSM: 6,
        },
        Select: {
            controlHeight: 38,
        },
    },
};

export default theme;
